<div (click)="triggerFileUpload()">
  <ng-content></ng-content>
</div>
